import {
  Flex,
  Grid,
  HStack,
  Skeleton,
  Text,
  useMediaQuery,
} from '@chakra-ui/react';

import { BleedBackground } from '../layouts';

export const RecipeHomepageSkeleton = () => {
  const [isMobile] = useMediaQuery('(max-width: 992px)');
  return (
    <Flex
      flexDirection="column"
      position="relative"
      px={{ base: '0', md: '4' }}
      py={{ base: '7', md: '8' }}
      gap="4"
    >
      <BleedBackground bg="#FEF9F2" />
      <HStack
        spacing="5"
        justifyContent={{ base: 'space-between', md: 'unset' }}
        alignItems="flex-end"
      >
        <Text
          as="span"
          fontSize={{ base: '22px', md: '2xl' }}
          fontWeight={{ base: 'regular', md: 'bold' }}
          lineHeight="1"
        >
          Resep Populer
        </Text>
        <Skeleton
          data-testid="skeleton-title"
          height="12px"
          width="100px"
          borderRadius="md"
        />
      </HStack>
      <Grid
        templateColumns="repeat(3, minmax(0, 1fr))"
        columnGap={{ base: '3', md: '8' }}
        rowGap={{ base: '6', md: '8' }}
      >
        {isMobile
          ? Array.from({ length: 6 }).map((_, index) => (
              <Skeleton
                data-testid="skeleton-card"
                key={index}
                h="106px"
                w="full"
                rounded="lg"
              />
            ))
          : Array.from({ length: 6 }).map((_, index) => (
              <Skeleton
                data-testid="skeleton-card"
                key={index}
                h="160px"
                w="full"
                rounded="xl"
              />
            ))}
      </Grid>
    </Flex>
  );
};
